"use client";

import ParallaxSpaceBg from "@/components/about/parallax-space-bg";
import { PiShootingStars } from "@/components/about/pi-shooting-stars";
import { TestimonialsCarousel } from "@/components/about/testimonials-carousel";
import { educatorTestimonials } from "@/components/educators/data/testimonials";
import { ClassroomIdeasSection } from "@/components/educators/sections/ClassroomIdeasSection";
import { EducatorPdfSection } from "@/components/educators/sections/EducatorPdfSection";
import { EducatorsHeroSection } from "@/components/educators/sections/EducatorsHeroSection";
import { FeaturedGamesByGradeSection } from "@/components/educators/sections/FeaturedGamesByGradeSection";
import { HollySpotlightSection } from "@/components/educators/sections/HollySpotlightSection";
import { MoreEducatorVoicesSection } from "@/components/educators/sections/MoreEducatorVoicesSection";
import { RecognitionSection } from "@/components/educators/sections/RecognitionSection";
import { RyanSpotlightSection } from "@/components/educators/sections/RyanSpotlightSection";
import { Footer } from "@/components/layout/footer";
import { Header } from "@/components/layout/header";
import { CommunitySection } from "@/components/partners/community-section";
import { EDUCATOR_PDF_SECTION_ENABLED } from "@/lib/constants/educator-printables";

export default function EducatorsPage() {
  return (
    <main id="main-content" className="relative min-h-screen flex flex-col">
      <ParallaxSpaceBg>
        <PiShootingStars />
      </ParallaxSpaceBg>
      <div className="relative z-10">
        <Header />

        <div className="flex-1">
          <EducatorsHeroSection />
          {EDUCATOR_PDF_SECTION_ENABLED ? <EducatorPdfSection /> : null}
          <HollySpotlightSection />
          <FeaturedGamesByGradeSection />
          <RyanSpotlightSection />
          {/* Same clothesline layout as About; no stars, no delayed intro slide-up */}
          <TestimonialsCarousel
            testimonials={[...educatorTestimonials]}
            showStars={false}
            enableIntroSlide={false}
          />
          <MoreEducatorVoicesSection />
          <ClassroomIdeasSection />
          <CommunitySection />
          <RecognitionSection />
        </div>

        <Footer />
      </div>
    </main>
  );
}
